/* eslint-disable */
import axios from 'axios';
import Cookie from 'js-cookie';
//import { has, forOwn, isUndefined, isNull, isNaN, isString, isEmpty, isObject, isArray, cloneDeep, pull } from 'lodash';

import forOwn from 'lodash/forOwn';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import isNaN from 'lodash/isNaN';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import cloneDeep from 'lodash/cloneDeep';
import pull from 'lodash/pull';

export const slugify = (slug) => {
    if (slug) {
        return slug
            .trimStart()
            .trimEnd()
            .replace(/[!#$\%^&\*\(\)\:;\'"|\\\{\}\[\]<>,\.\?\/~`=\+]/g, '')
            .replace(/[_ ]/g, '-')
            .replace('@', '-at-')
            .replace(/[-]+/g, '-')
            .toLowerCase();
    }
    return '';
};

export const slugifyKey = (slug) => {
    if (slug) {
        return slug
        .trimStart()
        .trimEnd()
        .replace(/[!#$\%^&\*\(\)\:;\'"|\\\{\}\[\]<>,\.\?\/~`=\+]/g, '')
        .replace(/[- ]/g, '_')
        .replace('@', '_')
        .replace(/[-]+/g, '_')
        .toLowerCase();
    }

    return '';

};

export const payMinMaxLabel = (job, prefix = '$') => {
    // override incoming prefix based on job currency and currency settings
    const showCodeOnly = window?.afConfig['show_currency_code_only'] === 'Yes';
    if (job.pay_currency) {
        if (showCodeOnly) {
            prefix = job.pay_currency.code ? (job.pay_currency.code + ' ') : '';
        } else if (job.pay_currency.symbol) {
            prefix = job.pay_currency.symbol;
        } else if (job.pay_currency.code) {
            prefix = job.pay_currency.code + ' ';
        }
    } else if (showCodeOnly) {
        prefix = '';
    }

    let suffix = '';
    if (job.pay_is_estimated || job.pay_hidden || (job.pay_min === 0 && job.pay_max === 0)) {
        return '';
    } else {
        if (job.pay_type === 'annual_salary') {
            suffix = 'Annually';
        } else if (job.pay_type === 'hourly_rate') {
            suffix = '/hr';
        } else if (job.pay_type === 'per_day') {
            suffix = 'Daily';
        }

        if (job.pay_min == '' && job.pay_max == '') {
            return '';
        }

        if (job.pay_min == '0.00' && job.pay_max == '0.00') {
            return '';
        }

        if (job.pay_min == null || job.pay_max == null) {
                return '';
            }

        if (job.pay_min === job.pay_max) {
            return `${prefix}${numberWithCommas(job.pay_max)} ${suffix}`;
        }
        if (job.pay_min === 0 || job.pay_min == null) {
            return `Up to ${prefix}${numberWithCommas(job.pay_max)} ${suffix}`;
        }

        if (job.pay_max === 0 || job.pay_max == null) {
            return `Starting from ${prefix}${numberWithCommas(job.pay_min)} ${suffix}`;
        }

        const showCodeAsSuffix = window?.afConfig['show_currency_code_as_suffix'] === 'Yes';

        let codeAsSuffix = '';
        if(showCodeAsSuffix && job.pay_currency?.code) {
            codeAsSuffix = `<span class="currency-code"><span>(</span>${job.pay_currency.code}<span>)</span></span>`;
        }

        return `<span class="pay-range">${prefix}${numberWithCommas(job.pay_min)} - ${prefix}${numberWithCommas(job.pay_max)}</span> ${codeAsSuffix} <span class="pay-type-code">${suffix}</span>`;
    }
}

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").split('.')[0];
}

export const downloadFileFromUrl = async (url, access_token = '') => {
    const config = {};
    const axios_instance = axios.create(config);
    axios_instance.defaults.headers.common = {};
    if (access_token) {
        axios_instance.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    }
    try {
        const response = await axios_instance.get(url, {responseType: 'blob'});
        return response;
    } catch(err) {
        return err;
    }
}
export const getSearchBaseUrl = () => {
    if (typeof window?.overrideAfConfig == 'function') {
        window.overrideAfConfig();
    }
    let base_url = `${process.env.BASE_URL}`;

    let custom_base_url = window?.afConfig?.base_url_search_result_page;
    if (custom_base_url) {
        base_url = `${base_url}${custom_base_url}`;
    } else {
        base_url = `${base_url}${window.location.hostname !== 'localhost' ? 'jobs' : 'search001' }`;
    }
    return base_url;
}

export const getJobViewBaseUrl = () => {
    if (typeof window?.overrideAfConfig == 'function') {
        window.overrideAfConfig();
    }
    let base_url = `${process.env.BASE_URL}`;

    let custom_base_url = window?.afConfig?.base_url_job_view_page;
    if (custom_base_url) {
        base_url = `${base_url}${custom_base_url}`;
    } else {
        base_url = `${base_url}${window.location.hostname !== 'localhost' ? 'jobview' : getJobViewTemplate() }`;
    }
    return base_url;
}

export const getApplyBaseUrl = () => {
    if (typeof window?.overrideAfConfig == 'function') {
        window.overrideAfConfig();
    }
    let base_url = `${process.env.BASE_URL}`;

    let custom_base_url = window?.afConfig?.base_url_apply_page;
    if (custom_base_url) {
        base_url = `${base_url}${custom_base_url}`;
    } else {
        base_url = `${base_url}${window.location.hostname !== 'localhost' ? 'apply' : 'apply001' }`;
    }
    return base_url;
}

export const getDashboardBaseUrl = () => {
    if (typeof window?.overrideAfConfig == 'function') {
        window.overrideAfConfig();
    }
    let base_url = `${process.env.BASE_URL}`;

    let custom_base_url = window?.afConfig?.base_url_dashboard_page;
    if (custom_base_url) {
        base_url = `${base_url}${custom_base_url}`;
    } else {
        base_url = `${base_url}${window.location.hostname !== 'localhost' ? 'user-dashboard' : 'dashboard001' }`;
    }
    return base_url;
}

export const loadMapScripts = (callback, loadClustererScript) => {
    // eslint-disable-next-line no-undef
    if (window.google && window.google.maps) {
        callback();

        return;
    }

    const apiKey = process.env.VUE_APP_GOOGLE_API_KEY;

    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?libraries=places,geometry&callback=mapScriptsLoaded&key=' + apiKey;
    script.async = true;

    if (loadClustererScript) {
        window.mapScriptsLoaded = () => {
            const script = document.createElement('script');
            script.src = 'https://unpkg.com/@googlemaps/markerclusterer@2.0.8/dist/index.min.js';
            script.async = true;
            document.head.appendChild(script);

            script.onload = callback;
        };
    } else {
        window.mapScriptsLoaded = callback;
    }

    document.head.appendChild(script);
}

export const getJobClassificationLink = (classification) => {
    return `${getSearchBaseUrl()}/cla_${classification.slug || slugify(classification.value)}/`;
}

export const getJobSubClassificationLink = (classification, subClassifiacation) => {
    return `${getSearchBaseUrl()}/cla_${classification.slug || slugify(classification.value)}_scla_${subClassifiacation.slug || slugify(subClassifiacation.value)}/`;
}

export const getJobViewTemplate = () => {
    if (process.env.NODE_ENV === "production") {
        return 'jobview';
    }

    return process.env.VUE_APP_LOCAL_JOBVIEW_TEMPLATE || 'jobview001';
};

export const getJobViewLink = (job_uuid) => {
    return `${getJobViewBaseUrl()}/${job_uuid}/`;
}

export const getJobPayMinMaxLabel= (job, currencySymbol) => {
    return payMinMaxLabel(job, currencySymbol);
}

export function removeNulls(obj) {
    return function prune(current) {
        forOwn(current, function (value, key) {
            if (isUndefined(value) || isNull(value) || isNaN(value) ||
                (isString(value) && isEmpty(value)) ||
                (isObject(value) && isEmpty(prune(value)))) {

                delete current[key];
            }
        });
        // remove any leftover undefined values from the delete
        // operation on an array
        if (isArray(current)) pull(current, undefined);

        return current;

    }(cloneDeep(obj));  // Do not modify the original object, create a clone instead
}


export function isNULLorEmpty(value) {

    return ((isUndefined(value) || isNull(value) || isNaN(value) ||
        (isString(value) && isEmpty(value)) ||
        (isObject(value) && isEmpty(value))));
}

export const formartCurrency = (str) => {
    var args = [].slice.call(arguments, 1),
        i = 0;
    return str.replace(/%s/g, () => args[i++]);
}

export function getUtmFromCookie() {
    const cookie = Cookie.get('utm');
    if (!cookie) {
        return null;
    }

    let utm;

    try {
        utm = JSON.parse(cookie);

        if (!utm || typeof utm !== 'object') {
            console.error('Invalid UTM cookie.');

            utm = null;
        }
    }
    catch (err) {
        utm = null;
    }

    return utm;
}

if (!String.prototype.format) {
    String.prototype.format = function() {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    };
}
